import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHouse,
  faPersonDress,
  faPerson,
  faGem,
} from "@fortawesome/free-solid-svg-icons";
import { Box, BottomNavigation, BottomNavigationAction } from "@mui/material";

export default function BottomNavigator({ navValue, setNavValue }) {
  const navigate = useNavigate(); // Hook is used inside a valid Router context
  const location = useLocation();
  const current_path = location.pathname;
  useEffect(() => {
    if (current_path == "/") {
      setNavValue(0);
    } else if (current_path.includes(`/product_list/2`)) {
      setNavValue(1);
    } else if (current_path.includes(`/product_list/1`)) {
      setNavValue(2);
    } else if (current_path.includes(`/product_list/3`)) {
      setNavValue(3);
    } else {
      setNavValue(-1);
    }
  }, [current_path, setNavValue]);

  const handleNavigation = (path, index) => {
    setNavValue(index); // Update the state
    navigate(path); // Navigate to the selected route
    // window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        boxShadow: 8,
        backgroundColor: "white",
        zIndex: 1000,
      }}
    >
      <BottomNavigation value={navValue >= 0 ? navValue : false} showLabels>
        <BottomNavigationAction
          label="Home"
          icon={<FontAwesomeIcon icon={faHouse} style={{ fontSize: "18px" }} />}
          onClick={() => handleNavigation("/", 0)}
          sx={{
            "&.Mui-selected": {
              color: "#bb8a47", // active icon + label color
            },
          }}
        />
        <BottomNavigationAction
          label="Women"
          icon={
            <FontAwesomeIcon
              icon={faPersonDress}
              style={{ fontSize: "18px" }}
            />
          }
          onClick={() => handleNavigation(`/product_list/2`, 1)}
          sx={{
            "&.Mui-selected": {
              color: "#bb8a47", // active icon + label color
            },
          }}
        />
        <BottomNavigationAction
          label="Men"
          icon={
            <FontAwesomeIcon icon={faPerson} style={{ fontSize: "18px" }} />
          }
          onClick={() => handleNavigation(`/product_list/1`, 2)}
          sx={{
            "&.Mui-selected": {
              color: "#bb8a47", // active icon + label color
            },
          }}
        />
        <BottomNavigationAction
          label="Jewellery"
          icon={<FontAwesomeIcon icon={faGem} style={{ fontSize: "18px" }} />}
          onClick={() => handleNavigation(`/product_list/3`, 3)}
          sx={{
            "&.Mui-selected": {
              color: "#bb8a47", // active icon + label color
            },
          }}
        />
      </BottomNavigation>
    </Box>
  );
}
